// src/index.ts
var ADMIN = "admin";
var BUREAU = "bureau";
var CONFIANCE = "confiance";
var HARD = "hard";
var PERSONNE = "personne";
var SG = "sg";
var SOFT = "soft";
var VIEUX = "vieux";
var CA = "ca";
var ACCUEIL_ARTISTE = "accueil-artiste";
var BAR = "bar";
var BARRIERES = "barrieres";
var BEBOO = "beboo";
var CATERING = "catering";
var LOG_ELEC = "elec";
var HUMAIN = "humain";
var LOG_MATOS = "matos";
var PAYANT = "payant";
var SCENE = "scene";
var SECU = "secu";
var SIGNA = "signa";
var RSE = "rse";
var COMMUNICATION = "communication";
var CONCERT = "concert";
var COURSES = "courses";
var CULTURE = "culture";
var DD = "dd";
var DECO = "deco";
var INFORMATIQUE = "informatique";
var PLAIZIR = "plaizir";
var SPONSO = "sponso";
var SPORTS = "sports";
var BDE = "bde";
var CVL = "cvl";
var KARNA = "karna";
var KFET = "kfet";
var ROUEN = "rouen";
var STRASBOURG = "strasbourg";
var HAUTS_DE_FRANCE = "hauts-de-france";
var CONDUCTEUR = "conducteur";
var CONDUCTEUR_FEN = "conducteur-fen";
var VOITURE = "voiture";
var CAMION = "camion";
var FEN = "fen";
var TEAM_ELEC = "team-elec";
var TEAM_MONTAGE = "team-montage";
var TECKOS = "teckos";
var TEAM_BOUFFE = "team-bouffe";
var TEAM_25EME = "25eme";
export {
  ACCUEIL_ARTISTE,
  ADMIN,
  BAR,
  BARRIERES,
  BDE,
  BEBOO,
  BUREAU,
  CA,
  CAMION,
  CATERING,
  COMMUNICATION,
  CONCERT,
  CONDUCTEUR,
  CONDUCTEUR_FEN,
  CONFIANCE,
  COURSES,
  CULTURE,
  CVL,
  DD,
  DECO,
  FEN,
  HARD,
  HAUTS_DE_FRANCE,
  HUMAIN,
  INFORMATIQUE,
  KARNA,
  KFET,
  LOG_ELEC,
  LOG_MATOS,
  PAYANT,
  PERSONNE,
  PLAIZIR,
  ROUEN,
  RSE,
  SCENE,
  SECU,
  SG,
  SIGNA,
  SOFT,
  SPONSO,
  SPORTS,
  STRASBOURG,
  TEAM_25EME,
  TEAM_BOUFFE,
  TEAM_ELEC,
  TEAM_MONTAGE,
  TECKOS,
  VIEUX,
  VOITURE
};
